import { useEffect, useRef, useState } from "react";
import { Image } from "primereact/image";
import { authorizationHeader } from "../service/apiConfig";
import { Button } from "primereact/button";

const CustomImage = (props) => {
    const [localSrc, setLocalSrc] = useState(null);
    const [fileType, setFileType] = useState(null);
    const [error, setError] = useState(null);

    const mimeTypeMap = {
        jpg: "image/jpeg",
        jpeg: "image/jpeg",
        png: "image/png",
        gif: "image/gif",
        webp: "image/webp",
        pdf: "application/pdf",
    };

    const getExtension = (url) => {
        const path = url.split("?")[0];
        const segments = path.split(".");
        return segments.length > 1 ? segments.pop().toLowerCase() : null;
    };

    const getFileName = (url) => {
        const path = url.split("?")[0];
        return path.split("/").pop() || "Document.pdf";
    };

    const handleDownload = () => {
        if (localSrc) {
            const link = document.createElement("a");
            link.href = localSrc;
            link.download = getFileName(props.src);
            document.body.appendChild(link);
            link.click();
            document.body.removeChild(link);
        }
    };

    useEffect(() => {
        const { src } = props;
        if (!src) return;

        let objectURL;
        fetch(src, authorizationHeader())
            .then(async (response) => {
                let contentType = response.headers.get("Content-Type");
                const ext = getExtension(src);

                if (!contentType || contentType.includes("json")) {
                    contentType = mimeTypeMap[ext];
                    if (!contentType) throw new Error(`Unsupported file extension: ${ext}`);
                }

                setFileType(contentType);
                const buffer = await response.arrayBuffer();
                const blob = new Blob([buffer], { type: contentType });
                objectURL = URL.createObjectURL(blob);
                setLocalSrc(objectURL);
            })
            .catch((err) => {
                console.error("Error fetching file in CustomImage:", err);
                setError(err.message);
                setFileType(null);
                setLocalSrc(null);
            });

        return () => {
            if (objectURL) {
                URL.revokeObjectURL(objectURL);
            }
        };
    }, [props.src]); // Dependency array ensures effect runs only when src changes

    const { src, alt, width, height, ...imageProps } = props;



    if (fileType === "application/pdf") {
        return (
            <div style={{ position: "relative", width, height }}>
                <iframe
                    src={localSrc}
                    title="PDF Preview"
                    width={width}
                    height={height}
                />
                <Button
                    icon="pi pi-download"
                    onClick={handleDownload}
                    className="relative border-round overflow-hidden"
                    style={{
                        width: width || "100%", height: height || "500px"
                        , position: "absolute",
                        top: "0px", right: "0px", left: "0px", Button: "0px",
                        opacity: 0,
                        background: "rgba(32, 31, 31, 0.5)",
                        border: "1px solid rgba(0, 0, 0, 0.3)", // Subtle border
                        transition: "opacity 0.3s ease", // Smooth fade-in effect
                    }}


                    onMouseEnter={(e) => (e.currentTarget.style.opacity = "0.7")} // Show on hover
                    onMouseLeave={(e) => (e.currentTarget.style.opacity = "0")} // Hide when not hovered
                />
            </div>
        );
    }

    return (
        <Image
            src={localSrc}
            alt={alt || getFileName(src)}
            width={width}
            height={height}
            {...imageProps}
        />
    );
};

export default CustomImage;